





































































































































import Vue from 'vue'
import { ChannelParams } from '@/types/PaginationParams.interface'
import ChannelStatus from '@/types/Channel.interface'
import User from '@/types/User.interface'

export default Vue.extend({
    data() {
        return {
            assigned: 'everyone',
            order_by: 'desc',
            status: null
        }
    },
    mounted() {
        //  Copy our params
        this.assigned = this.channelsParams.assigned
        this.order_by = this.channelsParams.order_by
        this.status = this.channelsParams.status
    },
    computed: {
        channelsParams(): ChannelParams {
            return this.$store.getters.inboxChannelsParams
        },
        defaults(): ChannelParams {
            return this.$store.getters.inboxChannelsParamsDefault
        },
        params(): ChannelParams {
            return {
                ...this.channelsParams,
                assigned: this.assigned,
                order_by: this.order_by,
                status: this.status,
                page: 1
            }
        },
        statusBorder(): Object {
            //  If status waiting is NOT selected then return null
            if (!this.status.waiting) return null

            //  If status new and status replied are NOT selected then return null
            if (!this.status.new && !this.status.replied) return null

            //  Else, our style starts off as an empty object
            let style = {}

            //  If status new is true, add a left border
            if (this.status === 'new') style['border-left'] = 'white 1px solid !important'

            //  If status replied is true, add a right border
            if (this.status === 'replied')
                style['border-right'] = 'white 1px solid !important'

            //  Return our style
            return style
        },
        users(): User[] {
            return this.$store.getters.users
        }
    },
    methods: {
        //  Emit selected params to the parent
        apply(): void {
            //  Emit our submit with payload
            this.$emit('submit', this.params)
        },
        //  Restore the filter to default params
        clear(): void {
            //  Get our default params (we clone here to avoid creating a reference from current and default params)
            const defaultParams = window._.cloneDeep(this.defaults)

            //  Reset our local variables
            this.assigned = 'everyone'
            this.order_by = 'desc'
            this.status = null

            //  Emit the default params
            this.$emit('submit', defaultParams)
        },
        //  Set the channel status
        setStatus(type: ChannelStatus): void {
            //  If our status is already this type, just set to null
            if (this.status === type) this.status = null
            //  Else, set it to our type
            else this.status = type
        }
    }
})
